import * as React from "react";
import { Outlet } from "react-router-dom";
import { Layout } from "antd";

export const AuthLayout: React.FC<{}> = () => {
  return (
    <Layout className="layout-auth">
      <Outlet />
    </Layout>
  );
};
